import countryData from 'src/utils/countryData.json';

const folder_colors: string[] = [
  '#C88BF8',
  '#9A8CF5',
  '#83B0E1',
  '#8DDCE1',
  '#6EBEA1',
  '#97DD62',
  '#EED064',
  '#EEB55C',
  '#EB5D2A',
  '#EB4A46',
];

const hashCode = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

export const getFolderColor = (folderId: string): string => {
  return folder_colors[Math.abs(hashCode(folderId)) % folder_colors.length];
};

const no_images = 10;

export const getClassImage = (courseId: string): string => {
  return `/images/course/cards/card_${
    Math.abs(hashCode(courseId)) % no_images
  }.png`;
};

// export const getCallingCodes = (): string[] => {
//   return countryData.countries.map(country => country.callingCode);
// };

export const getCallingCodes = (): {
  callingCode: string;
  countryName: string;
  emoji: string;
}[] => {
  const result: { callingCode: string; countryName: string; emoji: string }[] =
    [];

  countryData.forEach((country) => {
    // For each combined country code, create an object with the calling code, country name, and emoji
    country.idd.combined.forEach((combinedCode) => {
      result.push({
        callingCode: combinedCode,
        countryName: country.name.common,
        emoji: country.flag,
      });
    });
  });

  return result;
};

export const getCountries = (): {
  name: string;
  code: string;
}[] => {
  return countryData.map((country) => ({
    name: country.name.common,
    code: country.cca2,
  }));
};

const adminColorPalette: string[] = [
  '#F7DCDE',
  '#FFAEAD',
  '#FFD7A6',
  '#8AB3E4',
  '#E5F2FE',
  '#EDE9FF',
  '#88C0AA',
  '#CCE3DE',
  '#FEEB92',
  '#D8E085',
];

export const getColorFromSeed = (seed: string): string => {
  const index =
    Math.abs(
      seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
    ) % adminColorPalette.length;
  return adminColorPalette[index];
};

export const currencyOptions = [
  { value: 'GBP', name: 'British Pound', symbol: '£' },
  { value: 'EUR', name: 'Euro', symbol: '€' },
  { value: 'USD', name: 'US Dollar', symbol: '$' },
  { value: 'ZAR', name: 'South African Rand', symbol: 'R' },
  { value: 'MXN', name: 'Mexican Peso', symbol: '$' },
  { value: 'KRW', name: 'South Korean Won', symbol: '₩' },
  { value: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
].map(opt => ({
  ...opt,
  label: `${opt.name} (${opt.value})`
}));

export const currencyOptionsStripe = [
  { value: 'GBP', name: 'British Pound', symbol: '£' },
  { value: 'EUR', name: 'Euro', symbol: '€' }
].map(opt => ({
  ...opt,
  label: `${opt.name} (${opt.value})`
}));

export const getCurrencySymbol = (currencyCode: string): string => {
  const code = currencyCode?.toUpperCase() || '';
  const match = currencyOptions.find(opt => opt.value === code);
  return match ? match.symbol : code;
};

export const getCurrencyLabel = (currencyCode: string): string => {
  const code = currencyCode?.toUpperCase() || '';
  const match = currencyOptions.find(opt => opt.value === code);
  return match ? match.label : code;
};

export const getNormalizedLocale = (locale: string) => {

  const map = {
    'en-US': 'en-US',
    'en-GB': 'en-US',
    'zh-Hans-CN': 'zh-CN',
    'zh-HK': 'zh-CN',
    'zh-TW': 'zh-CN',
    'zh': 'zh-CN',
  };

  return map[locale] || locale || 'en';
}
